import React, {useState} from 'react'
import {Grid} from '@material-ui/core'
import {useDispatch, useSelector} from 'react-redux'
import {actions as authActions} from '../../redux/modules/auth'
import {RootState} from '../../redux/rootReducer'
import {RootGrid, Title, LoginButton, TextInput, ActivityIndicator} from './styled'
import {Alert} from '@material-ui/lab'

const LoginPage: React.FC = () => {
  const {dataState} = useSelector((state: RootState) => state.auth)
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const submitForm = () => {
    dispatch(authActions.login({email, password}))
  }
  return (
    <RootGrid container spacing={3}>
      <Grid item xs={12}>
        <Title>Login</Title>
      </Grid>
      <Grid container item xs={6} justify="flex-end">
        <TextInput
          placeholder="Email"
          value={email}
          onChangeText={setEmail}
          onSubmitEditing={submitForm}
        />
      </Grid>
      <Grid container item xs={6} justify="flex-start">
        <TextInput
          placeholder="Password"
          type="password"
          value={password}
          onChangeText={setPassword}
          onSubmitEditing={submitForm}
        />
      </Grid>
      <Grid container item xs={12} justify="center">
        {dataState.state === 'loading' ? (
          <ActivityIndicator />
        ) : (
          <LoginButton onClick={submitForm}>Login</LoginButton>
        )}
      </Grid>
      <Grid container item xs={12} justify="center">
        {dataState.error && <Alert severity="error">{dataState.error.message}</Alert>}
      </Grid>
    </RootGrid>
  )
}

export default LoginPage
